<template lang="html">
<div class="tablepanel">
<div class="new">
  <div class="table">
    <div class="table-header">
    <div class="table-row paddingleft">
      <div class="table-th w150">Consignee</div>
      <div class="table-th w150">City</div>
      <div class="table-th w150">LR Number</div>
      <div class="table-th w250">Reported At</div>
      <div class="table-th w250">Release At</div>
    </div>
  </div>
  <div class="table-bgcolor">
  <div class="table-row table-rowbg paddingleft" v-for="(consignee, index) in indentDetails.consignees" :key="index">
    <div class="table-td w150">
      <Ellipsis v-if="consignee.name.length"
        :text="consignee.name.toString(' ')"
        :length="10" />
    </div>
    <div class="table-td w150">{{consignee.city}}</div>
    <div class="table-td w150 table-td-break">
      <Ellipsis v-if="consignee.lr_number.toString().length"
        :text="consignee.lr_number.toString()"
        :length="10" />
            </div>
    <div class="table-td w250">{{consignee.delivered_at | moment("DD MMM YYYY | hh:mmA")}}</div>
    <div class="table-td w250">{{consignee.release_at | moment("DD MMM YYYY | hh:mmA")}}</div>
  </div>
</div>
</div>
</div>
</div>
</template>

<script>
export default {
  props: {
    indentDetails: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
